import moment from 'moment';

/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'PlanCommandService';

export default function PlanCommandService(Section, Structure, tableHelpersService) {
  "ngInject";

  function Command(subject, action, atomic) {
    this.subject = subject;
    this.action = action;
    this.atomic = atomic || false;
    this.time = new moment();

    if (subject.model != null) {
      console.warn('Command subject has internal model', subject);
    }
  }

  Command.prototype = {
    isEquivalentTo: function (command) {
      if ((!this.atomic && !command.atomic) &&
        (this.subject._id === command.subject._id) &&
        Math.abs(this.time.diff(command.time)) < 2000
      ) {
        switch (this.subject.type) {
          case tableHelpersService.Type:
            if (this.action !== command.action) {
              return false;
            }
            if (_.contains([], this.action)) {
              return true;
            }
            break;
          case Structure.Type:
            if (this.action !== command.action) {
              return false;
            }
            if (_.contains([Command.Actions.Move, Command.Actions.Label], this.action)) {
              return true;
            }
            break;
          case Section.Type:
            if (this.action !== command.action) {
              return false;
            }
            if (_.contains([Command.Actions.Move], this.action)) {
              return true;
            }
            break;
        }
      }
      return false;
    }
  };

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/
  Command.Actions = {
    Load: 'load',
    Save: 'save',
    Add: 'add',
    Remove: 'remove',
    Move: 'move',
    Rotate: 'rotate',
    Resize: 'resize',
    Stack: 'stack',
    Label: 'label',
    Edit: 'edit'
  };

  Command.createPlanLoad = function () {
    return new Command({
      type: 'plan',
      _id: 'plan'
    }, Command.Actions.Load, true);
  };

  Command.createUserSave = function () {
    return new Command({
      type: 'user',
      _id: 'user'
    }, Command.Actions.Save, true);
  };

  return Command;
}
